// extracted by css-extract-rspack-plugin
export default {"headerRule":"headerRule-zLrP0S","bulkActions":"bulkActions-lvnP3S","listScroll":"listScroll-qXelLO","checkbox":"checkbox-fPyXq3","checkboxList":"checkboxList-TRREV6"};